import { render, staticRenderFns } from "./subtitle-1.vue?vue&type=template&id=37813b0a&scoped=true&"
import script from "./subtitle-1.vue?vue&type=script&lang=js&"
export * from "./subtitle-1.vue?vue&type=script&lang=js&"
import style0 from "./subtitle-1.vue?vue&type=style&index=0&id=37813b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37813b0a",
  null
  
)

export default component.exports